import { SETTINGS_API_PATHS } from '../constants/api'
import type { StorefrontSettings } from '../constants/settings'
import { normalizeStorefrontSettings } from '../helpers/settings'
import { apiRequest } from './client'

export function fetchStorefrontSettings(): Promise<StorefrontSettings> {
  return apiRequest<unknown>(SETTINGS_API_PATHS.root, {
    method: 'GET',
  }).then(normalizeStorefrontSettings)
}
